var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDemo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DFA539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffa600"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "url(#gradient)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,10 l0,32 l30,0 l0,-32 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,10 c0,0 7,-5 15,-5 c8,0 15,5 15,5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,42 c0,0 7,-5 15,-5 c8,0 15,5 15,5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,5 v32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 15,
    width: 16,
    height: 10,
    rx: 2,
    transform: "rotate(-30, 5, 15)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 6,
    y: 22,
    fontSize: 6,
    fill: "url(#gradient)",
    transform: "rotate(-30, 5, 15)"
  }, "FREE"), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 25,
    r: 7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35,22 35,28 41,25",
    fill: "url(#gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemo);
export default __webpack_public_path__ + "static/media/demo.7ee7348bca63ad865c2eb22524e4a118.svg";
export { ForwardRef as ReactComponent };